import {
  FormControl,
  Checkbox,
  Text,
  type FormControlProps,
  type CheckboxProps,
} from '@chakra-ui/react';
import { type JSX } from 'react';
import {
  useFormContext,
  type FieldPath,
  type FieldValues,
  type RegisterOptions,
} from 'react-hook-form';

import { lodashGet } from '$/utils/lodash';

export interface HookFormCheckboxProps<T extends FieldValues>
  extends CheckboxProps {
  accessor: FieldPath<T>;
  label?: string;
  registerOptions?: RegisterOptions<T>;
  formControlProps?: FormControlProps;
  customLabelContent?: JSX.Element;
}

export const HookFormCheckbox = <T extends FieldValues>({
  label,
  accessor,
  registerOptions,
  formControlProps,
  customLabelContent,
  ...checkboxProps
}: HookFormCheckboxProps<T>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<T>();

  return (
    <FormControl
      borderColor='form.inputBorder'
      isInvalid={lodashGet(errors, accessor) != null}
      {...formControlProps}
    >
      <Checkbox
        alignItems='flex-start'
        colorScheme='primaryBlue'
        id={accessor}
        {...register(accessor, registerOptions)}
        {...checkboxProps}
      >
        {customLabelContent ?? (
          <Text mt='-1' fontSize='sm'>
            {label}
          </Text>
        )}
      </Checkbox>
    </FormControl>
  );
};
